import { LegalPageView } from "@/components/LegalPageView";

export default function Privacy() {
  return <LegalPageView page="privacy" title="Privacy Policy" />;
}
